

import auth from '../../../common/mixins/auth'
import alertWeb from '../../../common/mixins/alertWeb'
import redirectWeb from '../../../common/mixins/redirectWeb'

export default {
  name: 'Login',
  mixins: [auth, alertWeb, redirectWeb]
}
